import Calendar from "@assets/icons/calendar.svg";
import { MiniButton } from "@components/button";
import { ProfitFilterType } from "@components/profit-chart";
import classNames from "classnames";
import styles from "./chart-filter.module.scss";

type Props = {
  type: ProfitFilterType;
  setType: (type: ProfitFilterType) => void;
  className?: string;
};

export const ChartFilter = ({ type, setType, className }: Props) => {
  return (
    <div className={classNames(styles.filter, className)}>
      <span>Период</span>
      <div className={styles.buttons}>
        <MiniButton
          className={classNames(styles.button, type === "day" && styles.active)}
          onClick={() => setType("day")}
        >
          1D
        </MiniButton>
        <MiniButton
          className={classNames(
            styles.button,
            type === "week" && styles.active
          )}
          onClick={() => setType("week")}
        >
          1W
        </MiniButton>
        <MiniButton
          className={classNames(
            styles.button,
            type === "month" && styles.active
          )}
          onClick={() => setType("month")}
        >
          1M
        </MiniButton>
        <MiniButton
          className={classNames(
            styles.button,
            type === "year" && styles.active
          )}
          onClick={() => setType("year")}
        >
          1Y
        </MiniButton>
        <MiniButton className={classNames(styles.button, styles.calendar)}>
          <Calendar />
        </MiniButton>
      </div>
    </div>
  );
};
